<ng-template #userModalFormMore role="document" let-modal>
  
  <app-modal-comp-header
    [title]="formTitle"
    (cancelButtonOnClick)="moreFormCancel()"
  ></app-modal-comp-header>
  
  <form (ngSubmit)="moreFormSubmit()" [formGroup]="moreForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      <div class="row">
        <div class="col-12">
          <div class="mb-1">
            <label class="form-label text-right"></label>
            <div class="alert border-0 {{alertColourProgress}}" role="alert">
              <strong>Information</strong> - <span [innerHtml]="progressInformation" ></span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-1"></div>
        <div class="col-3">
          <div class="mb-1">
            <label for="username-field" class="form-label">Username</label>
          </div>
        </div>  
        <div class="col-7">
          <div class="mb-1">
            <input readonly type="text" id="username-field" class="form-control text-end border-0" placeholder="" formControlName="username" data-lpignore="true" />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      
      <div class="row">
        <div class="col-1"></div>
        <div class="col-3">
          <div class="mb-1">
            <label for="userId-field" class="form-label">User ID</label>
          </div>
        </div>  
        <div class="col-7">
          <div class="mb-1">
            <input readonly type="text" id="userId-field" class="form-control text-end border-0" placeholder="" formControlName="userId" data-lpignore="true" />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      
      <div class="row">
        <div class="col-1"></div>
        <div class="col-3">
          <div class="mb-1">
            <label for="inviewUserId-field" class="form-label">Inview User ID</label>
          </div>
        </div>  
        <div class="col-7">
          <div class="mb-1">
            <input readonly type="text" id="inviewUserId-field" class="form-control text-end border-0" placeholder="" formControlName="inviewUserId" data-lpignore="true" />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      
      <div class="row">
        <div class="col-1"></div>
        <div class="col-3">
          <div class="mb-1">
            <label for="firstname-field" class="form-label">Firstname</label>
          </div>
        </div>  
        <div class="col-7">
          <div class="mb-1">
            <input readonly type="text" id="firstname-field" class="form-control text-end border-0" placeholder="" formControlName="firstname" data-lpignore="true" />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      
      <div class="row">
        <div class="col-1"></div>
        <div class="col-3">
          <div class="mb-4">
            <label for="lastname-field" class="form-label">Lastname</label>
          </div>
        </div>  
        <div class="col-7">
          <div class="mb-4">
            <input readonly type="text" id="lastname-field" class="form-control text-end border-0" placeholder="" formControlName="lastname" data-lpignore="true" />
          </div>
        </div>
        <div class="col-1"></div>
      </div>
      
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8 mb-3">
          <div class="d-grid gap-2">
            <span class="d-grid" [title]="killUserHint">
              <button
                type="button"
                id="killUserButton"
                class="btn btn-soft-primary inline-block"
                [disabled]="killUserDisabled"
                [ngClass]="{ 'btn-soft-danger': highlightBtnKillUser }"
                (click)="killUser()"
                (mouseover)="killUserMouseOver()"
                (mouseleave)="killUserMouseLeave()"
              >
                Remove User
              </button>
            </span>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
      
      @if (curUser.systemAdmin) {
        <div class="row">
          <div class="col-12">
            <div class="form-check form-switch form-switch-md">
              <label class="form-check-label" for="killSureSimOnly-field">Remove from SureSIM Only</label>
              <input class="form-check-input" type="checkbox" role="switch" id="killSureSimOnly-field" formControlName="killSureSimOnly" (click)="killSureSimOnlyClick()">
            </div>
          </div>
        </div>
      }

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="moreFormCancel()">Close</button>
      </div>
    </div>
  </form>    
</ng-template>

<app-confirmation-modal-form #killUserConfirmationModal
  (modalYes)="yesKillUser()"
></app-confirmation-modal-form>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
